import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import type { MessageThread } from '../types';
import { threadPath, threadState, type ThreadSide } from '../utils/messageThreads';

/**
 * Where a stage's conversation stands, e.g. "Nytt meddelande" or "Läst", as a link
 * to its thread on Meddelanden (ClickUp 869feg849).
 */
export function MessageThreadStateLink({ thread, mySide }: { thread: MessageThread; mySide: ThreadSide }) {
  const { t } = useTranslation();
  const state = threadState(thread, mySide);
  const counterpart = t(`messageThreads.counterpart.${mySide === 'person' ? 'company' : 'person'}`);
  return (
    <Link
      to={threadPath(thread)}
      className="message-state-link"
      onClick={event => event.stopPropagation()}
      data-testid={`message-state-${thread.threadId}`}
    >
      <i className="feather-message-square" aria-hidden="true"></i>
      <span className={`messages-pill is-${state.tone}`}>{t(`messageThreads.state.${state.key}`, { counterpart })}</span>
      <span className="visually-hidden">{t('messageThreads.openThread')}</span>
    </Link>
  );
}
